import React, { Component } from 'react';
import { Link, browserHistory } from 'react-router';
import Footer from './footer.js';
import $ from 'jquery';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets/';
export default class CustomerCare_Seller extends Component {
constructor(props){
  super(props);
  this.state={
    email:'',
    mobiles:'',
    timings:'',
  }
}
componentDidMount(){
  if(screen.width >=800){
    window.location.href="/web/customer_care_seller";
  }
    var data1={from: 'mobile_web',user_id:localStorage.user_id};
    var data2=JSON.stringify(data1);
    $.ajax({
          method: 'POST',
          url: baseUrl+'getSellerSupportDetails',
          dataType:'json',
          data: {req:data2},
          success: function(data){
              this.setState({
                  email:data.email,
                  timings: data.timings,
                  mobiles: data.phone,
                  username:data.username,                  
              });
          }.bind(this),
          error: function(err){
            
          }
    });
}
	render(){
		document.title="Customer Care Partner | AquaDeals";
		return(

    <div className="mob_deals customer_care_page">
      <div className="page_hdr">
        <div className="container-fluid">
          <h5><Link onClick={()=>{browserHistory.goBack()}}><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt=""/></i></Link>Customer Care Partner</h5>
          <a href="/" className="home_logo1"><img src={baseAssets+'images/web_imgs/home1.png'} alt="Home" /></a>
        </div>
      </div>
    <div className="pag_cntnt customer_care">
        <div className="clr">&nbsp;</div>
        <div className="mod_cc_bg">
          <div>
            <img src={require('./../../../assets/images/cust_bg.png')} height="160" alt="..."></img>
          </div>
          <div className="mob_cc_image">
            <img src={require('./../../../assets/images/icon_cust_sup.png')} alt="..."></img>
          </div>            
        </div>
        <div className="container-fluid">
          <div className="col-md-12">
          <section id="cc_content_block">
            <h3>Dear <span>{this.state.username}</span> ,</h3>
            <p id="cc_cnt">If you have any questions or concerns about our products or services, feel free to contact our Customer Support team.</p>
          </section>
          <section id="cc_contact_list">
            <a href={"mailto:"+this.state.email}><p><span><img  src={require('./../../../assets/images/mail_icn.png')} /></span><span>{this.state.email}</span></p></a>
            <p><span><img  src={require('./../../../assets/images/phone_icn.png')} /></span><span dangerouslySetInnerHTML={{__html: this.state.mobiles}}></span></p>
            <p><span><img  src={require('./../../../assets/images/timer_icn.png')} /></span>{this.state.timings}</p>
          </section>
          {(this.state.zendesk_flag == 1) ? 
          <section id="cc_wb_div">
            <button className="cc_wb_btn" onClick={()=>{this.chatnow()}}><span id="cnt_wb_icon"><img  src={require('./../../../assets/images/wa_app.png')} width="20" /></span><span>CHAT NOW</span></button>
          </section>
          : ''}
            </div>
        </div>
      </div>
    {/*<Footer />*/}
{/* 
<div className="clr">&nbsp;</div>
<div className="clr">&nbsp;</div>
<div className="clr">&nbsp;</div>
<div className="clr">&nbsp;</div>
<div className="clr">&nbsp;</div>

  <section className="fxd_fotr row">
            <div className="col-md-12 col-xs-12 col-sm-12">
                <p>Downlaod the app to get a much Smoother<br />AquaDeals Experience</p>
                <a href="#">Open app</a>
            </div>
  </section>
*/}
    </div>

		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/Categories/Common/customer_care_seller.js
 **/